import { configure } from 'mobx'
import AuthenticatedUserStore from './AuthenticatedUserStore'
import NewsStore from './NewsStore'
import NotifierStore from './NotifierStore'

configure({ enforceActions: 'observed' }) // Enables strict mode for observed properties.

export const authenticatedUserStore = new AuthenticatedUserStore()
export const newsStore = new NewsStore()
export const notifierStore = new NotifierStore()
